module.exports = __webpack_public_path__ + "public/media/ic_check_circle_gray.731d9b7d.svg";